import { render, staticRenderFns } from "./TopTab.vue?vue&type=template&id=24d8c6c9&scoped=true&"
import script from "./TopTab.vue?vue&type=script&lang=js&"
export * from "./TopTab.vue?vue&type=script&lang=js&"
import style0 from "./TopTab.vue?vue&type=style&index=0&id=24d8c6c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d8c6c9",
  null
  
)

export default component.exports